<template>
  <div class="headerBonus">
    <h1>Lista de Bonos</h1>

    <v-data-table
      :headers="headers"
      :items="bonus"
      :header-props="{ class: 'red-header' }"
      :search="searchTerm"
    >
      <!-- Sección superior de la tabla -->
      <template v-slot:top>
        <div style="margin-bottom: 50px">
          <div class="row justify-space-between mx-auto">
            <v-text-field
              label="Buscador"
              placeholder="Ingrese por favor una palabra"
              append-icon="mdi-magnify"
              dense
              outlined
              class="col-md-5"
              @input="search"
            ></v-text-field>

            <div class="btn">
              <addBonus />
            </div>
          </div>
        </div>
      </template>

      <template v-slot:[`item.business`]="{ item }">
        <span class="custom-font">{{ item.business }}</span>
      </template>

      <template v-slot:[`item.title`]="{ item }">
        <span class="custom-font">{{ item.title }}</span>
      </template>

      <template v-slot:[`item.startDate`]="{ item }">
        <span class="custom-font">{{ formatDate(item.startDate) }}</span>
      </template>

      <template v-slot:[`item.endDate`]="{ item }">
        <span class="custom-font">{{ formatDate(item.endDate) }}</span>
      </template>

      <template v-slot:[`item.action`]="{ item }">
        <!-- Botón de acción para abrir el diálogo de detalles  -->
        <v-icon color="primary" size="x-large"></v-icon>

        <div class="actions">
          <detailBonus
            :bonusProps="item"
            style="margin-left: 1vh"
            ><v-btn icon x-large dark text>
              <v-icon class="mt-2" color="primary">mdi-border-color</v-icon>
            </v-btn>
          </detailBonus>

          <v-btn
            class="btnDetails"
            icon
            x-large
            dark
            text
            @click="confirmDeleteBonus(item.bondId)"
            style="background-color: transparent; margin-left: 1vh"
          >
            <v-icon color="primary">mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      max-width="600"
      persistent
    >
      <v-card class="container justify-content-between align-items-center">
        <button class="close-button" @click="closeDialog">
          <span class="small-x">X</span>
        </button>
        <v-col cols="12" md="12" sm="6">
          <img
            src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png"
            class="custom-img"
          />
        </v-col>
        <h2 class="custom-title">Eliminar Bono</h2>

        <v-row dense>
          <v-col cols="12" md="12" sm="12">
            <v-textarea
              color="secondary"
              label="*Observación"
              v-model="formData.observation"
              :counter="100"
              :maxlength="100"
              required
              :rules="messageRules"
              outlined
              @input="changeObservation"
            ></v-textarea>
          </v-col>
          <v-btn
            large
            block
            rounded
            :color="isSubmitting ? 'primary' : 'grey'"
            class="mb-4 custom-btn"
            style="color: white; border-radius: 50px"
            :disabled="!isSubmitting"
            @click="deleteBonus()"
          >
            Eliminar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import addBonus from "@/views/bonus/pages/add_bonus/add_bonus_page.vue";
import detailBonus from "@/views/bonus/pages/detail_bonus/detail_bonus_page.vue";
import EventBus from "@/utils/event_bus.js";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";

import {
  BONUS_M,
  GET_BONUS,
  ACTION_GET_BONUS,
  ACTION_DELETE_BONUS,
} from "@/views/bonus/store/types/types.js";

export default {
  name: "listBonusComponent",
  components: {
    addBonus,
    detailBonus,
  },

  data() {
    return {
      dialog: false,
      isSubmitting: false,
      bondId: null,
      searchTerm: "",
      messageRules: [(v) => !!v || "Obsevación requerida"],
      formData: {},
    };
  },

  async mounted() {
    await this.getActionBonus();

    EventBus.$on("reload-bonus", async () => {
      await this.reloadBonus();
    });

    EventBus.$on("reload-update-bonus", async () => {
      await this.reloadBonus();
    });
  },

  methods: {
    ...mapActions({
      getActionBonus: `${BONUS_M}${ACTION_GET_BONUS}`,
      deleteActionBonus: `${BONUS_M}${ACTION_DELETE_BONUS}`,
    }),

    async reloadBonus() {
      await this.getActionBonus();
    },

    search() {
      // Actualiza el término de búsqueda
      this.searchTerm = event.target.value;
    },

    closeDialog() {
      EventBus.$emit("close-dialog");
      this.dialog = false;
      window.location.reload();
    },

    async confirmDeleteBonus(bondId) {
      this.dialog = true;
      this.formData.bondId = bondId;
    },

    changeObservation() {
      if (this.formData.observation.trim()) {
        this.isSubmitting = true;
      } else {
        this.isSubmitting = false;
      }
    },

    async deleteBonus() {
      Swal.fire({
        title: "¿Estás seguro?",
        text: "Esta acción no se puede deshacer.",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "No, cancelar",
        confirmButtonColor: "#6E17A5",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const bondDelete = await this.deleteActionBonus(this.formData);
            await Swal.fire({
              position: "top-end",
              icon: "success",
              title: bondDelete.data.payload,
              showConfirmButton: false,
              timer: 2500,
            });
            this.closeDialog();
          } catch (error) {
            console.error("Error al eliminar:", error);
            Swal.fire({
              icon: "error",
              text: "Hubo un error al eliminar.",
            });
          }
        } else {
          await Swal.fire({
            position: "top-end",
            icon: "info",
            title: "Operación cancelada.",
            showConfirmButton: false,
            timer: 2500,
          });
          this.closeDialog();
        }
      });
    },

    formatDate(dateString) {
      return dateString.split("T")[0];
    },
  },

  computed: {
    ...mapGetters({
      bonus: [`${BONUS_M}${GET_BONUS}`],
    }),

    headers() {
      return [
        {
          text: "Comercio",
          value: "business",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Título",
          value: "title",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Fecha Inicio",
          value: "startDate",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          text: "Fecha Fin",
          value: "endDate",
          align: "center",
          sortable: false,
          class:
            "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
        },
        {
          //text: "Acciones",
          value: "action", // Cambiado de 'action' a 'actions'
          sortable: false,
          align: "center",
          //class: "primary--text custom-header mdi-pencil text-subtitle-1",
        },
      ];
    },
  },
};
</script>

<style lang="css" scoped>
.headerBonus h1 {
  margin-bottom: 30px;
}

.headerBonus {
  display: flex;
  gap: 40px;
  flex-direction: column;
  margin-top: 20px;
  margin-left: 20px;
}

.actions v-icon {
  font-size: 24px;
}
.custom-font {
  font-size: 20px;
}
/* Define los estilos (Tipo de letra) para las etiquetas h1,h2,h3,h4,h5,h6   */
body {
  font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Amsi Pro", sans-serif;
  color: #2d0049;
  font-weight: normal;
}

/* Estilos para el botón de eliminar */
.btnDetails .v-icon {
  color: #6e17a5;
  margin-bottom: 19px;
}

/**estilo de los iconos */
.actions {
  display: flex;
}

/* .marginIcon{
      margin-top: 12;
    } */

img {
  width: 3rem;
  height: 3rem;
}

.custom-img {
  width: 170px;
  height: auto;
  display: block;
  margin: 0 auto;
}

.custom-title {
  color: #6e17a5;
  justify-items: center;
}

.close-button {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
}

.small-x {
  font-size: smaller;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  color: #6e17a5;
}

.custom-btn {
  border-radius: 50px;
  padding: 12px;
}

@media screen and (max-width: 414px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }
  .custom-font {
    font-size: 13px;
  }
  img {
    margin-top: 18px;
    margin-bottom: auto;
    width: 3rem;
    height: 3rem;
  }
}

@media screen and (min-width: 414px) {
  h1 {
    font-size: 4vh;
    margin-left: 2vh;
  }
}

@media screen and (max-width: 280px) {
  h1 {
    font-size: 3vh;
    margin-left: 2vh;
  }
  h2 {
    font-size: 2vh;
  }
  .custom-font {
    font-size: 13px;
  }
  img {
    margin-top: 20px;
    margin-bottom: 10px;
    width: 3rem;
    height: 3rem;
  }
}
</style>
